<template>
    <span class="label" :class="color">
        {{ text }}
    </span>
</template>

<script>
    const colors = {
        free: {color: 'label-info', text: 'Free'},
        trial: {color: 'label-info', text: 'Trial'},
        unpaid: {color: 'label-success', text: 'Unpaid'},
        credited: {color: 'label-warning', text: 'Credited'},
        paid: {color: 'label-success', text: 'Paid'},
        overdue: {color: 'label-warning', text: 'Overdue'},
        'first-notice': {color: 'label-warning', text: 'First Notice'},
        'second-notice': {color: 'label-warning', text: 'Second Notice'},
        'third-notice': {color: 'label-warning', text: 'Third Notice'},
        'closing': {color: 'label-warning', text: 'Closing'},
        'closed': {color: 'label-danger', text: 'Closed'},
        'failed': {color: 'label-danger', text: 'Failed'},
        'uninvoiced': {color: 'label-success', text: 'Uninvoiced',},
        'drafted': {color: 'label-info', text: 'Draft',},

    }

    export default {
        props: {status: {}},

        computed: {
            color() {
                if (typeof this.status === 'undefined') {
                    return 'label-default'
                }

                return colors[this.status].color
            },

            text() {
                if (typeof this.status === 'undefined') {
                    return 'Unknown'
                }

                return colors[this.status].text
            }
        }
    }
</script>
